<section style="text-align: center">
    <h1>Page Not Found</h1>

    <p>Sorry, the page you are looking for doesn't appear to exist on the site.</p>
    <p>Please use the sidebar menu to navigate a different page, or simply go back.</p>
</section>